import { z } from 'zod/v4';

/**
 * Params of `POST /api/questionnaires/:id/save-as-template`.
 *
 * There is deliberately no body schema: the legacy route declared none and
 * accepted none. Every value on the clone is either derived (`name`, `status`,
 * `isTemplate`) or carried over from the source questionnaire, so the caller has
 * nothing to send beyond the id.
 *
 * The response is `CreatedQuestionnaireSchema` from `questionnaire-create.js`,
 * reused rather than redeclared — the clone is read back through the same
 * `getQuestionnaireByIdDb` projection the create and update responses use.
 */
export const SaveAsTemplateParamsSchema = z.object({
  id: z.string().min(1),
});

export type SaveAsTemplateParams = z.infer<typeof SaveAsTemplateParamsSchema>;
